import React, { useMemo } from 'react';
import { addYears, format, fromUnixTime } from 'date-fns';
import { useMutation } from '@apollo/client';
import { useModal } from '../../../../components/Modal';
import './ExtensionEnterprise.scss';
import InformationModal from '../../../../components/InformationModal/InformationModal';
import { EMembershipStatus, TMembershipData } from '../types';
import { SuccessModal } from './SuccessModal';
import { ENTERPRISE_EXTEND_SUBSCRIPTION } from '../../../../services/ApolloClient';
import { useApp, useError } from '../../../../contexts';

interface IExtensionEnterprisePropTypes {
  data: TMembershipData;
}

export const ExtensionEnterprise = ({ data }: IExtensionEnterprisePropTypes): React.JSX.Element => {
  const [enterpriseExtendSubscriptionMutation] = useMutation(ENTERPRISE_EXTEND_SUBSCRIPTION);
  const { showError } = useError();
  const { setLoading } = useApp();
  const {
    isOpen: isOpenExtendModal,
    closeModal: closeExtendModal,
    openModal: openExtendModal,
  } = useModal();
  const { isOpen: isOpenSuccessModal, openModal: openSuccessModal } = useModal();

  const newExpirationDate = useMemo(() => {
    const today = new Date();
    let newDate = addYears(today, 1);
    if (data.status === EMembershipStatus.active) {
      const expirationDate = fromUnixTime(data.timestamp);
      newDate = addYears(expirationDate, 1);
    }
    return format(newDate, 'MMMM do, y');
  }, [data.status, data.timestamp]);

  const handleExtendMembership = async () => {
    try {
      setLoading(true);
      const result = await enterpriseExtendSubscriptionMutation();
      setLoading(false);
      if (result.data.enterpriseExtendSubscription === true) {
        openSuccessModal();
      } else {
        showError();
      }
      closeExtendModal();
    } catch {
      setLoading(false);
      showError();
    }
  };

  return (
    <>
      <div className="extension-enterprise-container">
        <span className="action-link" onClick={openExtendModal}>
          Extend Enterprise Membership (at no cost to you)
        </span>
      </div>
      <InformationModal
        isOpen={isOpenExtendModal}
        onConfirmClick={handleExtendMembership}
        onClose={closeExtendModal}
        confirmBtnText="Extend Subscription"
        title="Extend Enterprise Subscription"
        informationText={`Your subscription will be extended until ${newExpirationDate}.`}
        message="You are eligible for another year of Every Mother as a benefit from your employer. To
            extend your membership for another year, press the button below."
      />
      <SuccessModal
        isOpen={isOpenSuccessModal}
        onClose={() => window.location.reload()}
        newExpirationDate={newExpirationDate}
      />
    </>
  );
};
